var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import _ from 'lodash';
import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Badge } from 'reactstrap';
import { ApplicationContext } from '../../../ApplicationContext';
import ActivityStatus from '../../../data/ActivityStatus';
import Routes from '../../../routes/RoutesConfig';
import AssetSignals from './signals/AssetSignals';
import AssetLabelFilterItem from './filters/AssetLabelFilterItem';
/**
 *
 */
var AssetsFilters = /** @class */ (function (_super) {
    __extends(AssetsFilters, _super);
    /**
     *
     * @param props
     */
    function AssetsFilters(props) {
        var _this = _super.call(this, props) || this;
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.onLabelFilterClick = _this.onLabelFilterClick.bind(_this);
        return _this;
    }
    /**
     *
     */
    AssetsFilters.prototype.render = function () {
        var _this = this;
        var session = this.context.session;
        var _a = this.props, className = _a.className, assetCollection = _a.assetCollection;
        var activeFilters = assetCollection.filter.activeFilters;
        var activityStatusValue = assetCollection.activityStatusFilter.value != null ? assetCollection.activityStatusFilter.value.toLowerCase() : '*';
        var labelsValue = assetCollection.labelsFilter.value != null && assetCollection.labelsFilter.value.length > 0 ? 'selected' : '*';
        return React.createElement("div", { className: 'assets-filters flex-fill d-flex ' + className },
            React.createElement("div", { className: "btn-group", role: "group" },
                activeFilters.length > 0 &&
                    React.createElement("button", { className: "btn ml-0 btn-white", onClick: function () {
                            assetCollection.filter.resetAllFilters();
                            _this.update();
                        } },
                        React.createElement("i", { className: activeFilters.length > 0 ? 'fe fe-x' : 'fe fe-filter' })),
                React.createElement("div", { className: "nav btn-group dropdown", role: "group" },
                    React.createElement("button", { className: 'btn ml-0 btn-white dropdown-toggle' + (activityStatusValue !== '*' ? ' active' : ''), type: "button", id: "activityFilterButton", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
                        React.createElement("div", { className: "d-none d-md-inline" },
                            React.createElement(FormattedMessage, { id: 'filters.activitystatus.' + activityStatusValue })),
                        React.createElement("span", { className: "d-md-none fe fe-activity" })),
                    React.createElement("div", { className: "dropdown-menu", "aria-labelledby": "activityFilterButton" },
                        React.createElement("a", { className: "dropdown-item", href: "#", onClick: function (event) {
                                _this.onFilterChange(event);
                            }, "data-filter-type": "ACTIVITY", "data-filter-value": "*" },
                            React.createElement(FormattedMessage, { id: "filters.activitystatus.*" })),
                        React.createElement("a", { className: "dropdown-item", href: "#", onClick: function (event) {
                                _this.onFilterChange(event);
                            }, "data-filter-type": "ACTIVITY", "data-filter-value": ActivityStatus.RECENT },
                            React.createElement(FormattedMessage, { id: "filters.activitystatus.recent" }),
                            React.createElement("i", { className: "ml-2 fe fe-check-circle text-success small" })),
                        React.createElement("a", { className: "dropdown-item", href: "#", onClick: function (event) {
                                _this.onFilterChange(event);
                            }, "data-filter-type": "ACTIVITY", "data-filter-value": ActivityStatus.EXPIRED },
                            React.createElement(FormattedMessage, { id: "filters.activitystatus.expired" }),
                            React.createElement("i", { className: "ml-2 fe fe-alert-circle text-warning small" })),
                        React.createElement("a", { className: "dropdown-item", href: "#", onClick: function (event) {
                                _this.onFilterChange(event);
                            }, "data-filter-type": "ACTIVITY", "data-filter-value": ActivityStatus.NONE },
                            React.createElement(FormattedMessage, { id: "filters.activitystatus.none" }),
                            React.createElement("i", { className: "ml-2 fe fe-x-circle text-danger small" })))),
                React.createElement("div", { className: "nav btn-group dropdown", role: "group" },
                    React.createElement("button", { className: 'btn ml-0 btn-white dropdown-toggle' + (labelsValue !== '*' ? ' active' : ''), type: "button", id: "labelsFilterButton", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
                        React.createElement("div", { className: "d-none d-md-inline" },
                            React.createElement(FormattedMessage, { id: 'filters.labels.' + labelsValue }),
                            labelsValue !== '*' ? React.createElement(Badge, { pill: true, color: "soft-primary ml-2" }, assetCollection.labelsFilter.value.length) : null),
                        React.createElement("span", { className: "d-md-none fe fe-tag" })),
                    React.createElement("div", { className: "dropdown-menu dropdown-menu-label", "aria-labelledby": "labelFilterButton" },
                        React.createElement("ul", { className: 'dropdown-label-list' }, assetCollection.uniqueLabels.map(function (labelModel) {
                            return React.createElement(AssetLabelFilterItem, { key: 'lm-' + labelModel.id, labelModel: labelModel, labelsFilter: assetCollection.labelsFilter, onClick: _this.onLabelFilterClick });
                        })),
                        assetCollection.uniqueLabels.length > 0 && session.user && session.user.isOwner &&
                            React.createElement("hr", { className: "w-100 my-2" }),
                        session.user && session.user.isOwner &&
                            React.createElement("div", { className: "d-flex justify-content-center w-100" },
                                React.createElement(Link, { to: Routes.LABELS.getPath() },
                                    React.createElement("i", { className: "fe fe-edit-2" }),
                                    " ",
                                    React.createElement(FormattedMessage, { id: "filters.labels.edit" })))))));
    };
    /**
     *
     * @param event
     */
    AssetsFilters.prototype.onFilterChange = function (event) {
        event.preventDefault();
        var assetCollection = this.props.assetCollection;
        var filterType = event.target.dataset.filterType;
        var filterValue = event.target.dataset.filterValue;
        switch (filterType) {
            case 'ACTIVITY':
                assetCollection.activityStatusFilter.value = filterValue === '*' ? null : filterValue;
                break;
            default:
            //none
        }
        this.update();
    };
    /**
     *
     * @param event
     */
    AssetsFilters.prototype.onLabelFilterClick = function (event) {
        event.preventDefault();
        event.stopPropagation();
        var assetCollection = this.props.assetCollection;
        if (assetCollection.labelsFilter.value === null) {
            assetCollection.labelsFilter.value = [];
        }
        var value = event.currentTarget.dataset.value;
        var checked = event.currentTarget.dataset.checked === 'true';
        if (!checked) {
            assetCollection.labelsFilter.value.push(value);
        }
        else {
            _.remove(assetCollection.labelsFilter.value, function (val) { return val === value; });
        }
        this.update();
    };
    /**
     *
     */
    AssetsFilters.prototype.update = function () {
        var assetCollection = this.props.assetCollection;
        assetCollection.updateFilterCache();
        assetCollection.update();
        AssetSignals.filtersChanged.dispatch();
        AssetSignals.zoomOut.dispatch();
        this.forceUpdate();
    };
    AssetsFilters.defaultProps = {
        className: ''
    };
    AssetsFilters = __decorate([
        observer
    ], AssetsFilters);
    return AssetsFilters;
}(React.Component));
AssetsFilters.contextType = ApplicationContext;
export default AssetsFilters;
